<template>
  <v-app class="login-bg" dark>
    <v-container fill-height>
      <v-layout align-center justify-center>
        <v-flex class="login-form text-xs-center">
          <div class="mb-3 text-h5">
            <img src="@/assets/agmify-logo-login.png" />
            <span class="ml-2"
              ><v-icon class="mr-2" dark>mdi-lock</v-icon>Login</span
            >
          </div>

          <v-card>
            <v-card-subtitle>Log in to your event portal</v-card-subtitle>
            <v-card-text>
              <v-form v-model="valid" ref="form">
                <v-text-field
                  label="Enter your e-mail address"
                  v-model="email"
                  :rules="emailRules"
                  required
                ></v-text-field>
                <v-text-field
                  label="Enter your password"
                  v-model="password"
                  min="8"
                  :append-icon="e1 ? 'mdi-eye' : 'mdi-eye-off'"
                  @click:append="e1 = !e1"
                  :type="e1 ? 'text' : 'password'"
                  :rules="passwordRules"
                  counter
                  required
                ></v-text-field>
                <div class="pb-1 red--text">{{ error }}</div>
                <v-layout justify-center>
                  <v-btn color="primary" @click="submit">Login</v-btn>
                </v-layout>
              </v-form>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </v-app>
</template>

<script>
import api from "@/services/api";
export default {
  data: () => ({
    error: "",
    valid: false,
    e1: false,
    password: "",
    passwordRules: [(v) => !!v || "Password is required"],
    email: "",
    emailRules: [
      (v) => !!v || "E-mail is required",
      (v) =>
        /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
        "E-mail must be valid"
    ]
  }),
  created() {
    // console.log("Login Page");
  },
  methods: {
    async submit(e) {
      if (this.$refs.form.validate()) {
        e.preventDefault();
        //this.$refs.form.$el.submit();
        await this.handleLogin();
      }
    },
    async handleLogin() {
      try {
        await api.login(this.email, this.password);
        const manager = await api.userProfile();

        if (manager) {
          this.$store.commit("SET_MANAGER", manager);
          this.$router.replace("/admin");
        }
      } catch (err) {
        this.error = err.error !== undefined ? err.error : err;
      }
    }
  }
};
</script>
<style>
#app.login-bg {
  /*background-image: url("https://images.unsplash.com/photo-1497733942558-e74c87ef89db?dpr=1&auto=compress,format&fit=crop&w=1650&h=&q=80&cs=tinysrgb&crop=");*/
  background-image: linear-gradient(#0d47a1, #00122c);
  background-size: cover;
  overflow: hidden;
  color: white;
  text-align: center;
}

.login-form {
  max-width: 400px !important;
}
</style>
